// extracted by mini-css-extract-plugin
module.exports = {"related-help-article":"RelatedHelpArticleSection_related-help-article__rR6K2"};